import React, { useEffect, useState } from 'react'
import APIUrls from '../../services/APIUrls';
import $ from "jquery";
import { getAxiosResponse, postAxiosResponse } from '../../services/authApiRoutes/APImethods';
import Constants from '../../Constants';
import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import { projectCreationStepFilter } from '../../redux/reducers/ProjectCreationStepSlice';
import { updateSourceLanguage } from '../../redux/reducers/CreateProjectSourceLanguageSlice';
import { updateTargetLanguage } from '../../redux/reducers/CreateProjectTargetLanguageSlice';
import { departmentSelected } from '../../redux/reducers/CreateProjectDepartmentSelectSlice';
import { updateProjectFollowers, updateProjectInfo } from '../../redux/reducers/ProjectInfoSlice';
import { updateInitializedProjectWorkflows } from '../../redux/reducers/InitializedProjectWorkflowsSlice';
import { updateSelectedProjectWorkflow } from '../../redux/reducers/SelectedProjectWorkflowSlice';
import { updateProjectInfoValidation } from '../../redux/reducers/ProjectInfoValidationSlice';
import { updateProjectInfoConfiguration } from '../../redux/reducers/ProjectInfoConfigurationSlice';
import { useDispatch } from 'react-redux';
import { updateAllUserGroupFollowers, updateFollowersCollection } from '../../redux/reducers/ProjectFollowersSlice';


export default function ProjectCreationWithTemplate({templates}) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [templateId,setTemplateId] = useState("");

    const createProjectWithTemplate = (e)=>{
        e.preventDefault();
        if(templateId !== ""){
            postAxiosResponse(APIUrls.PROJECT_TEMPLATE_BY_ID(templateId))
            .then((response)=>{
                const projectData = response.data.data;
                if(projectData !== ""){
                    const projectId = projectData.id;
                    hideAddModal();
                    dispatch(projectCreationStepFilter("Source Material Step 1"))               
                    dispatch(updateSourceLanguage({}));	
                    dispatch(updateTargetLanguage([]));	   
                    dispatch(departmentSelected(""));
                    dispatch(updateProjectFollowers([]));
                    dispatch(updateFollowersCollection([]));
                    dispatch(updateAllUserGroupFollowers([]));
                    dispatch(updateInitializedProjectWorkflows([]));
                    dispatch(updateSelectedProjectWorkflow({}));
                    dispatch(updateProjectInfoValidation({}));
                    dispatch(updateProjectInfoConfiguration({}));
                    dispatch(updateProjectInfo({}));
                    navigate(`/createProject/${projectId}?projectType=clone&label=${projectData?.userGroup?.name}&value=${projectData?.userGroup?.id}`);
                }
            }).catch((err)=>{
                console.error(err);
            })
        }
    };

    const handleTemplateChange = (e)=>{
        setTemplateId(e.value);
        enableCreateButton();
        
    };

    const hideAddModal = () => {
        setTemplateId("");
        disableCreateButton();
        document.body.classList.remove("modal-open-9");
    };

    const enableCreateButton = ()=>{
        const btn = $("#create-btn");
        if(btn.hasClass("disabled-btn")){
            btn.removeClass("disabled-btn");
        }
    };
    
    const disableCreateButton = ()=>{
        const btn = $("#create-btn");
        if(!btn.hasClass("disabled-btn")){
            btn.addClass("disabled-btn");
        }
    };

    const handleKeyAddflow = (event) => {
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            $("#template-id").trigger("focus");
          }
        }
    };

    return (
        <>
        <div className="lightbox-panel" id="modal-open-9" aria-labelledby="createtemplate" aria-modal="true" role="dialog">
            <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
                <div className="modal-header flex padd-lr">
                    <h5 id="createtemplate">Create Project with Template</h5>
                </div>
                <div className="lightbox-content padd-22 overflow-inherit">
                    <div className="global-dropdown-block mar-bot6">
                        <label>Project Template</label>
                        <Select className="global-dropdown-select isselectRemove" classNamePrefix="cw"
                            id="template-id"
                            options={templates}
                            defaultValue={templates !== undefined ? templates[0]:null}
                            onChange={(e) => handleTemplateChange(e)}
                            aria-label="Choose Template"
                        />
                    </div>
                </div>
                <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold first-focus cancelFocus" onClick={hideAddModal}>
                        Cancel
                    </button>
                    <button className="btn btn-bold active disabled-btn" id="create-btn"
                        onClick={(e)=>createProjectWithTemplate(e)} onKeyDown={handleKeyAddflow}>
                        Create
                    </button>
                </div>
            </div>
        </div>
        </>
    )
}
